import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { useState } from "react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import VpnKeyOutlinedIcon from "@mui/icons-material/VpnKeyOutlined";
import LogoImg from "../../assets/images/nocops-logo.png";
import "../Login/login.css";

export default function Signout(props) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (username === "Admin1" && password === "Admin@123") {
      const MyToken = "dtscustomtokenforlogin";
      localStorage.setItem("token", MyToken);
      navigate("/GardView", { replace: true });
    } else if (username === "Admin2" && password === "Admin@123") {
      const MyToken = "dtscustomtokenforlogin";
      localStorage.setItem("token", MyToken);
      navigate("/AttendentCard", { replace: true });
    } else {
      Swal.fire({
        icon: "error",
        title: "Error...",
        text: "Your username or password is incorrect.",
        background: "#141e33",
        color: "#f1f5f9",
        confirmButtonColor: "#3b82f6",
      });
    }
  };

  return (
    <Box className="loginPageBg">
      <Grid
        container
        component="main"
        sx={{
          display: "flex",
          alignContent: "center",
          justifyContent: "center",
          minHeight: "100vh",
        }}
      >
        <Grid item xs={12} sm={10} md={5} lg={4} xl={3} className="loginCard">
          <Box>
            <Box
              sx={{
                my: 3,
                mx: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img src={LogoImg} alt="NOCOPS Logo" className="loginLogo" />
              <Typography component="h1" variant="h5" className="loginTitle">
                Log In To Live Attendance
              </Typography>
              <Typography variant="body2" className="loginSubtitle">
                Gate / Security Kiosk Access
              </Typography>
            </Box>

            <Box
              component="form"
              onSubmit={handleSubmit}
              sx={{
                my: 1,
                mx: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box sx={{ width: "100%" }}>
                <Grid item xs={12} sx={{ display: "flex", alignItems: "center" }}>
                  <EmailOutlinedIcon sx={{ color: "#60a5fa", mr: 1, my: 0.5 }} />
                  <TextField
                    required
                    fullWidth
                    label="Username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    variant="outlined"
                    margin="normal"
                    autoComplete="username"
                    autoFocus
                    autoCapitalize="none"
                    inputMode="text"
                    type="text"
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sx={{ display: "flex", alignItems: "center" }}>
                  <VpnKeyOutlinedIcon sx={{ color: "#60a5fa", mr: 1, my: 1 }} />
                  <TextField
                    required
                    margin="normal"
                    autoComplete="current-password"
                    label="Password"
                    fullWidth
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoCapitalize="none"
                    inputMode="text"
                    type="password"
                    variant="outlined"
                    size="small"
                  />
                </Grid>

                <Button type="submit" fullWidth variant="contained" sx={{ mt: 2, mb: 1, py: 1.1 }}>
                  Log In
                </Button>
              </Box>
            </Box>
          </Box>

          <Typography variant="body2" className="loginFooter" align="center" {...props}>
            {"Copyright © "}
            <a
              href="https://www.dockyardsolutions.lk/"
              target="_blank"
              rel="noopener noreferrer"
              className="loginFooterLink"
            >
              Dockyard Total Solutions(Pvt)Ltd.
            </a>{" "}
            {new Date().getFullYear()}.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}
